"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M25.473 23.91a7.696 7.696 0 0 0-3.013-11.62 8.795 8.795 0 1 0-15.6 6.915l-1.528 1.517a1.1 1.1 0 0 0-.231 1.199 1.1 1.1 0 0 0 1.011.681h6.256A7.696 7.696 0 0 0 19.305 27h6.596a1.1 1.1 0 0 0 1.012-.682 1.1 1.1 0 0 0-.231-1.198l-1.21-1.21zm-13.864-4.606c.002.368.031.736.088 1.1H8.762l.385-.374a1.1 1.1 0 0 0 0-1.562 6.52 6.52 0 0 1-1.935-4.661 6.597 6.597 0 0 1 6.596-6.597 6.53 6.53 0 0 1 6.212 4.398h-.715a7.696 7.696 0 0 0-7.696 7.696zm11.588 5.497.055.055h-3.947a5.497 5.497 0 1 1 3.892-1.605 1.1 1.1 0 0 0-.33.77 1.1 1.1 0 0 0 .33.78z"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=ChatDuoOutlined.js.map